import React from 'react';
import styles from './BookEasyPen.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

function BookEasyPen({ initModal }) {
  return (
    <div className={cx('BookEasyPen')}>
      <div className="detail-wrap-box">
        <div className="close" onClick={initModal}></div>
        <div className="detail-title">
          <h2>교재 / 이지펜 상세 스펙</h2>
        </div>

        <div className="datail-contents">
          <div className="detail-subtitle">
            <h3>교재</h3>
          </div>
          <div className="detail-text">
            <ul className="detail-text-list">
              <li className="list">
                <span className="title">총 구성</span>
                <span className="text">12권</span>
              </li>
              <li className="list pb-21">
                <span className="title">1권당 수록곡</span>
                <span className="text">팝송 30곡</span>
              </li>
              <li className="list">
                <p className="">교재에 이지펜을 찍으면 음성이 바로 재생돼요</p>
              </li>
            </ul>
          </div>

          <div className="detail-subtitle">
            <h3>이지펜</h3>
          </div>
          <div className="detail-text">
            <ul className="detail-text-list">
              <li className="list">
                <span className="title">제품명</span>
                <span className="text">이지펜</span>
              </li>
              <li className="list">
                <span className="title">모델명</span>
                <span className="text">P40</span>
              </li>
              <li className="list">
                <span className="title">제조사</span>
                <span className="text">시노텍코리아(주)</span>
              </li>
              <li className="list">
                <span className="title">기본구성</span>
                <span className="text">
                  이지펜 본체, USB 충전 케이블, 사용 설명
                </span>
              </li>
              <li className="list">
                <span className="title">사이즈</span>
                <span className="text">125mm X 25mm X 20mm</span>
              </li>
              <li className="list">
                <span className="title">스피커</span>
                <span className="text">1.0W 내장 스피커</span>
              </li>
              <li className="list">
                <span className="title">메모리</span>
                <span className="text">16GB</span>
              </li>
              <li className="list">
                <span className="title">배터리</span>
                <span className="text">420mAh 내장 배터리</span>
              </li>
              <li className="list">
                <span className="title">무게</span>
                <span className="text">50g</span>
              </li>
            </ul>
            <p className="etc">
              교재와 이지펜의 배송 및 환불 관련 정보는 '패키지 자세히보기'를
              확인해주세요.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookEasyPen;
